<template>
  <div class="menu-page">
    <label v-for="item in menus">
      <el-menu-item v-if="item.child_node.length === 0"
                    :index="$route.path + '?menu=' + $route.query.menu + '&id=' + item.id">
        <i :class="item.icon"></i>
        <span class="padding text-ellipsis block" slot="title">{{item.title}}</span>
      </el-menu-item>
      <el-submenu
          v-if="item.child_node.length !== 0" :index="$route.path + '?menu=' + $route.query.menu + '&id=' + item.id">
        <template slot="title">
          <span class="text-ellipsis block padding">{{item.title}}</span>
        </template>
        <Menu :menus="item.child_node"></Menu>
      </el-submenu>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    props: ['menus'],
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="scss">
  .menu-page {
    .el-submenu {
      background-color: #F4F5F6;
    }
    .el-submenu__title{
      height: 40px;
      line-height: 40px;
      &:hover{
        background-color: #F4F5F6;
        i,span{
          color: #F46322;
        }
      }
      &:active{
        background-color: rgba(255,255,255,0.5);
        i,span{
          color: #F46322;
        }
      }
    }
    .el-menu-item {
      height: 40px;
      line-height: 40px;
      background-color: #F4F5F6;
      padding-right: 10px;
      border-left: 3px #f4f5f6 solid;
      &:hover{
        background-color: #F4F5F6;
        i,span{
          color: #F46322;
        }
      }
      &.is-active{
        background: #fff;
        border-left-color: #F16622;
        color: #F46322;
        box-sizing: border-box !important;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .padding{
    padding: 0 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/doc/menu.vue